import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { EntregaObraClienteArquivoAuxModel } from "../../models/entrega_obra_cliente_arquivo_aux";
import { IGetAllEntregaObraClienteArquivoAuxUseCase } from "../../../presentation/useCases/read/get_all_entrega_obra_cliente_arquivo_aux_use_case";

/**
 * GetAllEntregaObraClienteArquivoAuxUseCase
 */

export class GetAllEntregaObraClienteArquivoAuxUseCase
  extends BasePaginatedUseCase<EntregaObraClienteArquivoAuxModel>
  implements IGetAllEntregaObraClienteArquivoAuxUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(idEntregaObraCliente: number): Promise<void> {
    const result = await this.repository.getAllEntregaObrasClienteArquivosAux(idEntregaObraCliente);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }
}
